<div class="form-component">
    <h4>
        Define Claim Data Rows to Import
    </h4>

    <form #form="ngForm">

        <div class="input-field">
            <label for="headerIndex">
                Header Row:<span class="required">*</span>
            </label>
            <input type="number" id="headerIndex" name="headerIndex" class="header" [(ngModel)]="model.headerIndex" required />
            <p class="error-message" *ngIf="form.submitted && form.invalid">
                Header Row is required.
            </p>
        </div>

        <div class="input-field">
            <label for="startIndex">
                Start Row:<span class="required">*</span>
            </label>
            <div>
                <input type="number" id="startIndex" name="startIndex" class="start" [(ngModel)]="model.startIndex" required>
                <p class="error-message" *ngIf="form.submitted && form.invalid">
                    Start Row is required.
                </p>
            </div>
        </div>

        <div class="input-field">
            <label for="endIndex">
                End Row:<span class="required">*</span>
            </label>
            <div>
                <input type="number" id="endIndex" name="endIndex" class="end" [(ngModel)]="model.endIndex" required>
                <p class="error-message" *ngIf="form.submitted && form.invalid">
                    End Row is required.
                </p>
            </div>
        </div>
    </form>
</div>

<h4 class="secondary-header">
    Data Preview
</h4>

<div class="data-preview-container" [class.wide]="isWideTable" *ngIf="firstTenRows.length > 0 || lastTenRows.length > 0; else noData">
    <table class="data-preview-table" [class.wide]="isWideTable">
        <thead>
            <tr [class.header-row]="firstTenRows[0]?.rowNumber === model.headerIndex">
                <th>{{ firstTenRows[0]?.rowNumber }}</th>
                <th *ngFor="let header of firstTenRows[0]?.rowValues">
                {{ header || '' }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of firstTenRows.slice(1)" [class.header-row]="row?.rowNumber === model.headerIndex" [class.start-row]="row?.rowNumber === model.startIndex" [class.end-row]="row?.rowNumber === model.endIndex">
                <td class="row-number">{{ row?.rowNumber }}</td>
                <td *ngFor="let cell of row?.rowValues">{{ cell || '' }}</td>
            </tr>

            <tr class="row-separator">
                <td colspan="100%">...</td>
              </tr>

              <tr [class.header-row]="lastTenRows[0]?.rowNumber === model.headerIndex">
                <th>{{ lastTenRows[0]?.rowNumber }}</th>
                <th *ngFor="let header of lastTenRows[0]?.rowValues">
                  {{ header || '' }}
                </th>
              </tr>

              <!-- The remaining rows -->
              <tr *ngFor="let row of lastTenRows.slice(1)" [class.header-row]="row?.rowNumber === model.headerIndex" [class.start-row]="row?.rowNumber === model.startIndex" [class.end-row]="row?.rowNumber === model.endIndex">
                <td class="row-number">{{ row?.rowNumber }}</td>
                <td *ngFor="let cell of row?.rowValues">{{ cell || '' }}</td>
              </tr>
        </tbody>
    </table>
</div>

<ng-template #noData>
    <div *ngIf="loading" class="loading-indicator">
        <div class="spinner"></div>
        Loading Excel data... This may take a moment for larger files.
    </div>
    <ng-container *ngIf="!loading">
        <p>No data available to preview. Please verify your selections.</p>
    </ng-container>
</ng-template>